











































import { defineComponent } from '@vue/composition-api';
import { MeetingDto } from '@/generated/api.clients';
import { UserStoreKey } from '@/store/StoreInjectionKeys';
import { injectStrict } from '@/lib/utils';
import router from "@/router";

export default defineComponent({
  props: {
    meeting: {
      type: MeetingDto,
      required: true
    }
  },
  setup(props) {
    const userStore = injectStrict(UserStoreKey);

    function goToActivity(): void {
      if (props.meeting.meetingType == "Goal")
        router.push(`/learner/Goals/${props.meeting.learnerId}`)
      else
        router.push(`/learner/${props.meeting.learnerId}/Activity/${props.meeting.meetingActivityId}`)
    }

    function switchContextUser(): void {
      router.push(`/learner/Goals/${props.meeting.learnerId}`)
    }

    return {
      goToActivity,
      switchContextUser,
      userStore
    }
  }
})
